import React, {Component} from 'react'
import {Accordion, Icon} from 'semantic-ui-react'

class LogOfChanges extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {
      active: false
    }

    this.toggleAccordion = this.toggleAccordion.bind(this)
  }

  toggleAccordion() {
    this.setState({active: !this.state.active})
  }

  render() {
    let {active} = this.state
    let {logs} = window.editVpoPage

    return (
      <div style={{marginBottom: '50px'}}>
        <Accordion>
          <Accordion.Title onClick={this.toggleAccordion} style={{fontSize: '16px', fontWeight: 'bold'}}>
            <Icon name='dropdown' style={active ? {transform: 'rotate(90deg)'} : {}}/>
            Log of Changes ({logs.length})
          </Accordion.Title>
          <Accordion.Content active={active}>
            {
              logs.length == 0
              ?
              <div>No changes made yet</div>
              :
              <ul>
                {
                  logs.map((log) => {
                    return (
                      <li>{log.userName} on {log.dateString} &nbsp; — &nbsp; {log.message}</li>
                    )
                  })
                }
              </ul>
            }
          </Accordion.Content>
        </Accordion>
      </div>
    )
  }
}

export default LogOfChanges
